'use strict';

var React = require('react');

var SvgOutdentIcon = function SvgOutdentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5h-12.5Zm7 3.5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Zm-.75 4.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Zm-6.25 2.75a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5h-12.5Zm4.25-2.093c0 .473-.55.755-.96.493l-3.765-2.408a.579.579 0 0 1 0-.985l3.765-2.407c.41-.262.96.02.96.493v4.814Z"
  }));
};
SvgOutdentIcon.displayName = "OutdentIcon";

exports.SvgOutdentIcon = SvgOutdentIcon;
